import { useDispatch } from 'store/hooks';
import { streamParmUpdatesAction } from './thunks';
import { useCallback } from 'react';

export const useDispatchStreamParmUpdates = () => {
    const dispatch = useDispatch();
    return useCallback(
        (key: string) => {
            dispatch(streamParmUpdatesAction(key));
        },
        [dispatch]
    );
};
